<script module>
  const storeLogos = {
    '01253': 'baner.png',
    '01292': 'bea.png',
    '01437': 'brottby.png',
    '00977': 'ettan.png',
    '01447': 'flygfyren.png',
    '09259': 'hajen.png',
    '01256': 'karlaplan.png',
    '01940': 'city.png',
    '01942': 'city.png',
    '01952': 'city.png',
    '01201': 'stop.svg',
    '01160': 'tappstrom.png',
    '15076': 'taby-metro.png',
    '00966': 'matkassen.svg',
    '12313': 'haggvik.png',
    '14926': 'faltoversten.png',
    '01429': 'LogoTorghallenEhandel.png',
    '01158': 'LogoNKallhallEhandel.png',
    '01254': 'LogoICASMEsplanadEhandel.png'
  }

  export const hasCustomLogo = (id) => {
    return Object.hasOwn(storeLogos, id)
  }
</script>

<script>
  let { id, name } = $props();
</script>

<img
  alt={name}
  src={`https://assets.icanet.se/image/upload/q_auto,f_auto,h_200/ecom-assets/custom-store-logos/${storeLogos[id]}`}
/>
